import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Autoplay, Navigation } from 'swiper/modules';

import './Pdf.scss';
import allyojana from "../../../assets/pdf/allyojana.pdf"
import mahila from "../../../assets/pdf/mahila.pdf"
import mahayuti from "../../../assets/pdf/mahayuti.pdf"
import mahamanav from "../../../assets/pdf/mahamanav.pdf"
import pamplatevote from "../../../assets/pdf/pamplatevote.pdf"
import alpsankhyank from "../../../assets/pdf/alpsankhyank.pdf"
import bhajpa from "../../../assets/pdf/bhajpa.pdf"

function Pdf() {

    return (
        <>

            <div className="pdf-parent parent">

                <div className="pdf-container ">

                    <Swiper
                        spaceBetween={10}
                        slidesPerView={3}
                        centeredSlides={false}

                        autoplay={{
                            delay: 2500,
                            disableOnInteraction: false,
                            pauseOnMouseEnter: true,
                        }}
                        pagination={{
                            clickable: true,
                        }}                      

                        breakpoints={{
                          
                            300: {
                                slidesPerView: 1,
                                spaceBetween: 10,
                            },
                            755: {
                                slidesPerView: 2,
                                spaceBetween: 20,
                            },

                            1141: {
                                slidesPerView: 3,
                                spaceBetween: 10,
                            },
                         
                            1570: {
                                slidesPerView: 4,
                                spaceBetween: 10,
                            },
                        }}
                        navigation={true}
                        modules={[Autoplay, Navigation]}
                        className="pdfSwiper"

                    >


                        <SwiperSlide>
                            <a href={allyojana} download="../../../assets/pdf/allyojana.pdf" >
                                <div className="pdf-card">

                                    <div className=" 
                                
                                pdf-card-img1 bg-img-cover pdf-card-img"></div>
                                    <a href={allyojana} download="allyojana.pdf" className='btn'>Download Pdf</ a>
                                </div>
                            </a>
                        </SwiperSlide>
                        {/* -----------second---------- */}
                        <SwiperSlide>
                            <a href={mahila} download="../../../assets/pdf/mahila.pdf" >
                                <div className="pdf-card">
                                    <div className=" pdf-card-img pdf-card-img1 bg-img-cover bg-img-cover pdf-card-img2"></div>
                                    <a href={mahila} download="mahila.pdf" className='btn'>Download Pdf</ a>
                                </div>
                            </a>
                        </SwiperSlide>


                        {/* ----Third---- */}

                        <SwiperSlide>
                            <a href={mahayuti} download="../../../assets/pdf/mahayuti.pdf" >
                                <div className="pdf-card">
                                    <div className="pdf-card-img bg-img-cover pdf-card-img3"></div>
                                    <a href={mahayuti} download="MAHAYUTI VACHANAMA.pdf" className='btn'>Download Pdf</ a>
                                </div>
                            </a>
                        </SwiperSlide>

                        {/* ----fourth----- */}
                        <SwiperSlide>
                            <a href={mahamanav} download="../../../assets/pdf/mahamanav.pdf" >
                                <div className="pdf-card">
                                    <div className="pdf-card-img bg-img-cover pdf-card-img4"></div>
                                    <a href={mahamanav} download="mahamanav.pdf" className='btn'>Download Pdf</ a>
                                </div>
                            </a>
                        </SwiperSlide>

                        {/* ------fifth------- */}
                        <SwiperSlide>
                            <a href={pamplatevote} download="../../../assets/pdf/pamplatevote.pdf" >
                                <div className="pdf-card">
                                    <div className="pdf-card-img bg-img-cover pdf-card-img5"></div>
                                    <a href={pamplatevote} download="pamplatevote.pdf" className='btn'>Download Pdf</ a>
                                </div>
                            </a>
                        </SwiperSlide>
                        {/* ------sixth------- */}
                        <SwiperSlide>
                            <a href={pamplatevote} download="../../../assets/pdf/alpsankhyank.pdf" >
                                <div className="pdf-card">
                                    <div className="pdf-card-img bg-img-cover pdf-card-img6"></div>
                                    <a href={alpsankhyank} download="alpsankhyank samaj.pdf" className='btn'>Download Pdf</ a>
                                </div>
                            </a>
                        </SwiperSlide>
                        {/* -----------seventh------- */}
                        <SwiperSlide>
                            <a href={bhajpa} download="../../../assets/pdf/bhajpa.pdf" >
                                <div className="pdf-card">
                                    <div className="pdf-card-img bg-img-cover pdf-card-img7"></div>
                                    <a href={bhajpa} download="bhajpa.pdf" className='btn'>Download Pdf</ a>
                                </div>
                            </a>
                        </SwiperSlide>

                    </Swiper>
                </div>
            </div>

        </>
    )
}

export default Pdf